import { PinosTerritorioQuery, TerritorioMapaImovelQuery } from 'graphql/types.generated'

export const PINO_TERRITORIO_MODAL_ROUTE = 'pino'

export type TerritorioPinoQueryModel = PinosTerritorioQuery['pinosTerritorio']

export type TerritorioPinoModel = TerritorioPinoQueryModel['content'][number]

export type TerritorioPinoComCoordenadas = TerritorioPinoModel & { latitude: number; longitude: number }

export type TerritorioMapaImovelModel = NonNullable<TerritorioMapaImovelQuery['imovel']>

export type TerritorioMapaFamiliaResidenteModel = TerritorioMapaImovelModel['familias'][number]
